// This file is generated by NTypewriter using scriban template (_Models.nt), DO NOT MODIFY THIS FILE
/* tslint:disable */
// @ts-ignore We don't have the means in codegen to determine if this symbol is actually used or not in the context of code we're about to emit so ignore unused warning.
import { TodaysLinesModel } from './TodaysLinesModel';
// @ts-ignore We don't have the means in codegen to determine if this symbol is actually used or not in the context of code we're about to emit so ignore unused warning.
import { TopLineUsageContext } from './TopLineUsageContext';

/**
 *  
 */
export class TodaysLinesServiceClient {

    /**
     * get: api/TodaysLines?context=${context}&isExternal=${isExternal}
     */
    public static RouteGet = (context: TopLineUsageContext, isExternal: boolean) => `/api/TodaysLines?context=${context}&isExternal=${isExternal}`;
    /**
     * 
     */
    public static async get(context: TopLineUsageContext, isExternal: boolean): Promise<TodaysLinesModel> {
        const url = TodaysLinesServiceClient.RouteGet(context, isExternal);
        const method: string = 'get';
        const data: any = null;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetch(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

}

/**
 *  
 */
export class TodaysLinesRequestFactory {

    /**
     * get: api/TodaysLines?context=${context}&isExternal=${isExternal}
     */
    public static RouteGet = (context: TopLineUsageContext, isExternal: boolean) => `/api/TodaysLines?context=${context}&isExternal=${isExternal}`;
    /**
     * 
     */
    public static async get(fetcher: (url: string, init: RequestInit) => Promise<Response>, context: TopLineUsageContext, isExternal: boolean): Promise<TodaysLinesModel> {
        const url = TodaysLinesServiceClient.RouteGet(context, isExternal);
        const method: string = 'get';
        const data: any = null;
        const isFormData = false;
        const fetchParams: RequestInit = {
            method: method,
            credentials: 'same-origin'
        };
        if (method == "post") {
            if (isFormData) {
                const fd = new FormData();
                for (const key in data) {
                    fd.append(key, data[key]);
                }
                fetchParams.body = fd;
            } else {
                fetchParams.body = ((data && typeof(data) == 'string') ? data : JSON.stringify(data));
                var h = new Headers();
                h.append("Content-Type", "application/json");
                fetchParams.headers = h;
            }
        }
        const resp = await fetcher(url, fetchParams);
        if (!resp.ok) {
            throw { statusCode: resp.status, resp }
        }
        return await resp.json();
    }

}


// WEBPACK FOOTER //
// ./src/model/autogen/TodaysLinesController.ts